<template>
    <div id="Divider">
        <p class="container">{{Msg}}~</p>
    </div>
</template>
<script>
    export default {
        props:{
            Msg:{
                type:String,
                default:'没有更多了'
            }
        }
    }
</script>
<style lang="scss" scoped>
@import "~@/scss/libs.scss";
    .container {
        display: table;
        white-space: nowrap;
        height: auto;
        overflow: hidden;
        line-height: 1;
        text-align: center;
        padding: px2rem(25) 0;
        color: #7b7f81;
        font-size: px2rem(28);
        &::after,
        &::before {
            content: '';
            display: table-cell;
            position: relative;
            top: 50%;
            width: 50%;
            background-image: url(~@/assets/images/border.png);
            background-repeat: no-repeat; 
        }
        &::before {
            background-position: right 1em top 50%;
        }
        &::after {
            background-position: left 1em top 50%;
        }
    }
</style>

